import { render, staticRenderFns } from "./OffstreetPropertyMapping.vue?vue&type=template&id=4f95ac18&scoped=true"
import script from "./OffstreetPropertyMapping.vue?vue&type=script&lang=js"
export * from "./OffstreetPropertyMapping.vue?vue&type=script&lang=js"
import style0 from "./OffstreetPropertyMapping.vue?vue&type=style&index=0&id=4f95ac18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f95ac18",
  null
  
)

export default component.exports